import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { NoteReclamationState } from './state';

export const getters: GetterTree<NoteReclamationState, RootState> = {
    getJwt(state): string {
        return state.jwt;
    },
};
